// import hooks
import { usePlanUnitsOptions } from 'hooks';

// import types
import type { BacklogPlanUnitId } from '../../../../Backlog.types';
import type { BacklogPlanUnitOption } from './BacklogPlanUnitFilter.types';

/**
 * The remembered plan unit ids as the plan units themselves.
 *
 * What is remembered across visits is ids, not plan units: a plan unit is a record with a validity window
 * and cost centres of its own, so a stored copy would go quietly out of date — and the employee and function
 * lists are asked for its cost centres, which is the last thing that should be answered from a stale
 * snapshot. Resolving here against the plan units the app has loaded keeps them current, and an id that no
 * longer resolves drops out: a plan unit that has gone stops filtering rather than filtering on nothing.
 *
 * The same options list the field itself shows, so a resolved pick is always one the planner can see and
 * untick again.
 */
export const usePickedPlanUnits = (
  planUnitIds: BacklogPlanUnitId[]
): BacklogPlanUnitOption[] => {
  const options = usePlanUnitsOptions({ showGroups: true });

  return options.filter(({ uniqId }) => planUnitIds.includes(uniqId));
};
